// extracted by mini-css-extract-plugin
export default {"SidebarNav":"SidebarNavPsjLhj-ax_HJ","SidebarNav-content-wrapper":"SidebarNav-content-wrapper9Uv8LE6GJKap","SidebarNav-content":"SidebarNav-content1y65DOep-YvE"};